import React,{useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jmethod(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
  <Sides/>
  <Helmet>
 
 <title>Java Method tutorial For Beginners</title>
<meta name="description" content="Java Method tutorial for beginners.Methods in java contain one more statement and each method performs only one task" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,java method,java methods,for method java,what is java method,java method main,java method call,java method equals,java method overloading,java method generics,compareto method java,java method signature,java method overriding,java methods list,java method list,java method example,java method class
,java method reference,java method header,java method definition,java method parameter
,java method declaration,java method length,java method naming convention" />
<link rel="canonical" href="https://www.codeexampler.com/java-method" />
</Helmet>

<div className='lg:pl-56'>


    <h1 className="m-4 mh1">Methods in Java</h1>
    <div className="first">
        <a href="/java-class-and-object">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-user-defined-function">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">1, The methods in java contain one more statement and each method performs only one task
        <br/>
        2, Each method gives the name and after this name is used to call the method.  
    </p>


<h2 className="headings">Methods in Java Syntax:</h2>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
            
              {"\n"}
              <span className="qwerty-10">Method name</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-4"> parenthesis or parameter-list</span>
              <span className="qwerty-1">);</span>
              {"\n"}
              <span className="qwerty-3">&#123; </span>
              {"\n"}
                 
             
              <span className="qwerty-5">&nbsp;&nbsp;{`// body of method  `}</span>
        
              {"\n"} 
              <span className="qwerty-3">&#125; </span>
                {"\n"}
        
           
            </code>
          </pre>        
        </div>





<h2 className="headings">Q-Write a Program use one method in Java Example?</h2>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
            
              {"\n"}
              <span className="qwerty-10">class</span>
              <span className="qwerty-4"> school</span>
              {"\n"}
              <span className="qwerty-3">&#123; </span>
              {"\n"}
              <span className="qwerty-7">&nbsp;&nbsp;public </span>
              <span className="qwerty-3">void </span>
              <span className="qwerty-8">teachers</span>
              <span className="qwerty-1">()</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp; &#123; </span>
              {"\n"}
              <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">out</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">println</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-4">"teaching"</span>
              <span className="qwerty-1">);</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
              {"\n"}{"\n"}    
               
                <span className="qwerty-7">&nbsp; &nbsp;public </span>
              <span className="qwerty">static </span>
              <span className="qwerty-3">void </span>
              <span className="qwerty-8">main </span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-2">String</span>
              <span className="qwerty-1">[] </span>
              <span className="qwerty-1">args</span>
              <span className="qwerty-1">) </span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
              {"\n"}
              <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">out</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">println</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-4">"start method"</span>
              <span className="qwerty-1">);</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;school</span>
              <span className="qwerty-4"> s</span>
              <span className="qwerty-8"> = </span>
              <span className="qwerty-5">new </span>
              <span className="qwerty-4">school</span>
              <span className="qwerty-1">();</span>
              {"\n"} 
              <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;s</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-4">teachers</span>
              <span className="qwerty-1">();</span>
              {"\n"}     
             
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
              {"\n"} 
              <span className="qwerty-3">&#125; </span>
                {"\n"}
        
           
            </code>
          </pre>        
        </div>
        
        <div>
          <h3 className="headings">Output</h3>
          <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
            <pre style={{ maxHeight: '500vh' }}>
              <code className="python hljs">
              {"\n"}
              <span className="qwerty-10">&nbsp;start method</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;teaching</span>
              {"\n"}
                </code>{"   "}
                </pre>
          </div>
        </div>



<h2 className="headings">Q-Write a Program Use two methods and create a different object for different methods?</h2>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
            
              {"\n"}
              <span className="qwerty-10">class</span>
              <span className="qwerty-4"> school</span>
              {"\n"}
              <span className="qwerty-3">&#123; </span>
              {"\n"}
              <span className="qwerty-7">&nbsp;&nbsp;public </span>
              <span className="qwerty-3">void </span>
              <span className="qwerty-8">teachers</span>
              <span className="qwerty-1">()</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp; &#123; </span>
              {"\n"}
              <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">out</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">println</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-4">"teaching"</span>
              <span className="qwerty-1">);</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
              {"\n"}{"\n"}   
              {"\n"}
              <span className="qwerty-7">&nbsp;&nbsp;public </span>
              <span className="qwerty-3">void </span>
              <span className="qwerty-8">students</span>
              <span className="qwerty-1">()</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp; &#123; </span>
              {"\n"}
              <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">out</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">println</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-4">"learn"</span>
              <span className="qwerty-1">);</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
              {"\n"}{"\n"}    
               
                <span className="qwerty-7">&nbsp; &nbsp;public </span>
              <span className="qwerty">static </span>
              <span className="qwerty-3">void </span>
              <span className="qwerty-8">main </span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-2">String</span>
              <span className="qwerty-1">[] </span>
              <span className="qwerty-1">args</span>
              <span className="qwerty-1">) </span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
              {"\n"}
              <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">out</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">println</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-4">"start method"</span>
              <span className="qwerty-1">);</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;school</span>
              <span className="qwerty-4"> s</span>
              <span className="qwerty-8"> = </span>
              <span className="qwerty-5">new </span>
              <span className="qwerty-4">school</span>
              <span className="qwerty-1">();</span>
              {"\n"} 
              <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;s</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-4">teachers</span>
              <span className="qwerty-1">();</span>
              <span className="qwerty-5">{`// first method  `}</span>
              {"\n"}   
              <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;s</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-4">students</span>
              <span className="qwerty-1">();</span>
              <span className="qwerty-5">{`// second method  `}</span>
              {"\n"}   
             
        
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
              {"\n"} 
              <span className="qwerty-3">&#125; </span>
                {"\n"}
        
        
            </code>
          </pre>        
        </div>
        
        <div>
          <h3 className="headings">Output</h3>
          <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
            <pre style={{ maxHeight: '500vh' }}>
              <code className="python hljs">
              {"\n"}
              <span className="qwerty-10">&nbsp;start method</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;teaching</span>
              {"\n"}
              <span className="qwerty-10">&nbsp;learn</span>
              {"\n"}
                </code>{"   "}
                </pre>
          </div>
        </div>

<h2 className="mt-4 mh2">Important:</h2>
<p className="mt-4 para">You create multiple objects you do but programming run speed is decreased so create less object to gain high speed. 
</p>




<h2 className="headings">Q- Write a Program using different classes in java Method?</h2>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
              {"\n"}
              <span className="qwerty-10">class</span>
              <span className="qwerty-4"> schoolPeon</span>
              {"\n"}
              <span className="qwerty-3">&#123; </span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;void </span>
              <span className="qwerty-8">peon</span>
              <span className="qwerty-1">()</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp; &#123; </span>
              {"\n"}
              <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">out</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">println</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-4">"this is peon"</span>
              <span className="qwerty-1">);</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
              {"\n"}
              <span className="qwerty-3">&#125; </span>
              {"\n"}
              <span className="qwerty-10">class</span>
              <span className="qwerty-4"> school</span>
              {"\n"}
              <span className="qwerty-3">&#123; </span>
              {"\n"}
              <span className="qwerty-7">&nbsp;&nbsp;public </span>
              <span className="qwerty-3">void </span>
              <span className="qwerty-8">teachers</span>
              <span className="qwerty-1">()</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp; &#123; </span>
              {"\n"}
              <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">out</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">println</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-4">"teaching"</span>
              <span className="qwerty-1">);</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
              {"\n"}{"\n"}   
              {"\n"}
              <span className="qwerty-7">&nbsp;&nbsp;public </span>
              <span className="qwerty-3">void </span>
              <span className="qwerty-8">students</span>
              <span className="qwerty-1">()</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp; &#123; </span>
              {"\n"}
              <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">out</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">println</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-4">"learn"</span>
              <span className="qwerty-1">);</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
              {"\n"}{"\n"}    
               
                <span className="qwerty-7">&nbsp; &nbsp;public </span>
              <span className="qwerty">static </span>
              <span className="qwerty-3">void </span>
              <span className="qwerty-8">main </span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-2">String</span>
              <span className="qwerty-1">[] </span>
              <span className="qwerty-1">args</span>
              <span className="qwerty-1">) </span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
              {"\n"}
              <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">out</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">println</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-4">"start method"</span>
              <span className="qwerty-1">);</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;school</span>
              <span className="qwerty-4"> s</span>
              <span className="qwerty-8"> = </span>
              <span className="qwerty-5">new </span>
              <span className="qwerty-4">school</span>
              <span className="qwerty-1">();</span>
              <span className="qwerty-10">{`// create new object `}</span>
              {"\n"}    
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;school</span>
              <span className="qwerty-4"> t</span>
              <span className="qwerty-8"> = </span>
              <span className="qwerty-5">new </span>
              <span className="qwerty-4">school</span>
              <span className="qwerty-1">();</span>
              <span className="qwerty-10">{`// create other new object  `}</span>
              {"\n"} 
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;schoolPeon</span>
              <span className="qwerty-4"> p</span>
              <span className="qwerty-8"> = </span>
              <span className="qwerty-5">new </span>
              <span className="qwerty-4">schoolPeon</span>
              <span className="qwerty-1">();</span>
              {"\n"}
              <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;s</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-4">teachers</span>
              <span className="qwerty-1">();</span>
              {"\n"}   
              <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;t</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-4">students</span>
              <span className="qwerty-1">();</span>
              {"\n"}  
              <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;p</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-4">peon</span>
              <span className="qwerty-1">();</span>
              {"\n"}  
             
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
              {"\n"} 
              <span className="qwerty-3">&#125; </span>
                {"\n"}
        
            </code>
          </pre>        
        </div>
        
        <div>
          <h3 className="headings">Output</h3>
          <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
            <pre style={{ maxHeight: '500vh' }}>
              <code className="python hljs">
              {"\n"}
              <span className="qwerty-10">&nbsp;start method</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;teaching</span>
              {"\n"}
              <span className="qwerty-10">&nbsp;learn</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;this is peon</span>
              {"\n"}
                </code>{"   "}
                </pre>
          </div>
        </div>

<h3 className="mt-4 mh3">Multiple classes in Java Steps follow </h3>
<p className="mt-4 para">If you create multiple classes in one program and call methods  from all classes so firstly you check in which class you write main() method and after you create multiple objects from multiple classes inside main () method class  and after by the name of an object call method from main () method class
</p>

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/java-class-and-object">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-user-defined-function">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Jmethod;